<template>
  <div class="registerContainer" v-show="RegisterShow">
    <div class="background">
        <section class="main clearfix">
          <i class="el-icon-close" @click="colse"></i>
          <div class="contFr fr">
            <el-form style="width=400px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="1px" class="demo-ruleForm">
              <el-form-item label="" prop="mobile" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/phone1.png" alt="" />
                <el-input class="input clearfix" placeholder="请输入您的手机号" maxlength="11" v-model="ruleForm.mobile"></el-input>
              </el-form-item>

              <el-form-item label="" prop="passWord" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/paswd1.png" alt="" />
                <el-input class="input clearfix" placeholder="请输入密码/8-12位数字及字母组合而成" show-password minlength="8" maxlength="12" v-model="ruleForm.passWord"></el-input>
              </el-form-item>

              <el-form-item label="" prop="repeatpassWord" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/paswd1.png" alt="" />
                <el-input class="input clearfix" placeholder="请确认密码" show-password maxlength="12" v-model="ruleForm.repeatpassWord"></el-input>
              </el-form-item>

              <el-form-item label="" prop="regCode" class="formItems1" style="margin-bottom:22px;">
                <div class="clearfix">
                  <el-input class="input" placeholder="请输入计算结果" v-model="ruleForm.regCode"></el-input>
                </div>
                <img @click="getImgCodes" class="codeBox imgCode" :src="imgCode" alt="图形验证码" />
              </el-form-item>

              <el-form-item label="" prop="verifyCode" class="formItems1">
                <div class="clearfix">
                  <el-input class="input" placeholder="请输入短信验证码" v-model="ruleForm.verifyCode"></el-input>
                </div>
                <span @click="getCode()" class="codeBox code">{{codeTxt}}</span>
              </el-form-item>

              <el-form-item label="" prop="checked" style="text-align: left;margin-top:10px;">
                <el-checkbox-group v-model="ruleForm.checked" size="mini" style="display: inline-block;">
                  <el-checkbox class="myRedCheckBox" label="我已阅读并同意"></el-checkbox>
                </el-checkbox-group>
                <span class="agreement" @click="agreementS(1)">《注册协议》</span>
                <span class="agreement" @click="agreementS(2)">《隐私协议》</span>
              </el-form-item>
              <el-form-item style="margin-bottom:0;">
                <p class="register" type="primary" @click="submitForm('ruleForm')">注册账号</p>
                <a class="goLogin" href="javascript:void(0)" @click="goLogin">已有账号，去登录</a>
              </el-form-item>
            </el-form>
          </div>
        </section>
    </div>
    <div class="agreement_Model" v-show="agreement_Show">
      <div class="agreement_box">
        <p class="agreement_Title">
          <span>{{agreementState==1?"注册协议":"隐私协议"}}</span>
          <i @click="agreement_Show = false" class="el-icon-close"></i>
        </p>
        <div class="agreement_Content">
          <div v-html="agreement"></div>
        </div>
      </div>
    </div>
    
    <Messages ref="messages" :tips="tipsTxt" />
  </div>
</template>

<script>
import Messages from "@/components/Messages"
import { mapState } from 'vuex';
import {regist,sendPhoneValidCode} from "@/api/index.js" 
import {getBySpmkey} from "@/api/homeApi.js" 
import { timestamp,isCellPhone} from "@/utils/proof-technique.js"
export default {
  data() {
    // 密码
    let validatePass = (rule, value, callback) => {
		  let reg= /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{8,15}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      }else if(!reg.test(value)){
        callback(new Error('密码必须是由8-15位字母+数字组合'))
      } else {
        if (this.ruleForm.repeatpassWord !== "") {
				this.$refs.ruleForm.validateField("repeatpassWord");
        }
        callback();
      }
    };
    // 确认密码
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.passWord) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      codeTxt:"获取验证码",
      imgCode:"",
      ruleForm: {
        checked:false,
        mobile:"",
        passWord:"",
        repeatpassWord:"",
        regCode:"",
        verifyCode:"",
      },
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            required: true,
            validator: isCellPhone,
            trigger: "blur",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: validatePass,
            trigger: "blur",
          },
          {
            min: 8,
            max: 12,
            message: "长度在8到12个字符",
            trigger: "blur",
          },
        ],
        repeatpassWord: [
          {
            required: true,
            message: "请再次输入密码",
            trigger: "blur",
          },
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        verifyCode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        regCode: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
        // phone: [
        //   { required: true, message: '请输您的手机号', trigger: 'blur' },
        //   // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ],
      },
      flag:true,
      timer:"",
      interval:null,
      tipsTxt:"",
      agreement:"",
      agreementState:1,
      agreement_Show:false,
    }
  },
  components:{
    Messages,
  },
  methods: {
    colse(){
        this.$store.dispatch("ChangeRegisShow");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.checked) {
            this.$message({
              type: "warning",
              message: "请阅读并勾选协议",
            });
            return;
          }
          let paswd = this.ruleForm.passWord,paswd1 = this.ruleForm.repeatpassWord;
              paswd = this.hrymd5.md5(paswd);
              paswd1 = this.hrymd5.md5(paswd1);
          regist({
            mobile:this.ruleForm.mobile,
            passWord:paswd,
            repeatpassWord:paswd1,
            regCode:this.ruleForm.regCode,
            verifyCode:this.ruleForm.verifyCode,
            uid:this.timer
          }).then(res=>{
            if(res.data.success){
              this.tipsTxt = "注册成功";
              this.$refs.messages.show = true;
              setTimeout(() => {
                this.$store.dispatch("ChangeRegisShow");
                this.$store.dispatch("ChangeLoginShow");
              }, 800);
            }else{
              if(res.data.msg && res.data.msg!=""){
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            }
          }).catch(err=>{
            console.log(err)
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    beforeDestroy(){
      clearInterval(this.interval);
    },
    goLogin(){
      this.$store.dispatch("ChangeRegisShow");
      this.$store.dispatch("ChangeLoginShow");
    },
    getCodeApi(){
      sendPhoneValidCode({
        mobile:this.ruleForm.mobile,
        regCode:this.ruleForm.regCode,
        uid:this.timer
      }).then(res=>{
        if(res.data.success){
          let numB = 60;
          this.flag = false;
          this.$message({
            message: '验证码已发送，请注意查收',
            offset:300,
            type: 'success'
          });
          this.interval = setInterval(() => {
            numB--;
            this.codeTxt = numB + " S 后重新获取";
            if(numB == 0){
              clearInterval(this.interval);
              numB = 0;
              this.codeTxt = "获取验证码";
              this.flag = true;
            }
          }, 1000);
        }else{
          if(res.data.msg && res.data.msg!=""){
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      }).catch(err=>{
        console.log(err)
      });
    },
    getCode(){
      let mobile = this.ruleForm.mobile;
      let regCode = this.ruleForm.regCode;
      if (!mobile) {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
      }else if (!regCode) {
        this.$message({
          type: "warning",
          message: "图形验证码不能为空",
        });
      }else if(this.flag){
        this.getCodeApi();
      }else{
        this.$message({
          message: '倒计时后才能重新获取！',
          offset:300,
          type: 'warning'
        });
      }
    },
    getImgCodes(){
      this.timer = timestamp();
      this.imgCode = process.env.BASE_API + "/code/regCode?uid=" + this.timer;
    },
    agreementS(i){
      this.agreement = "";
      this.agreement_Show = true;
      this.agreementState = i;
      this.getagreement(i);
    },
    getagreement(i){
      getBySpmkey({
        spmkey:i==1?"xykey":"yinsi",
      }).then(res=>{
        if(res.data.success){
          this.agreement = res.data.obj.protocolContent;
        }else{
          if(res.data.msg && res.data.msg!=""){
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      }).catch(err=>{
        console.log(err)
      });
    },
  },
  computed: {
    ...mapState(['IsLogin','LoginShow','RegisterShow']),
  },
  mounted(){
    this.getImgCodes();
  }
}
</script>

<style lang="less" scoped>
    .registerContainer{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: 0;
        z-index: 80;
        max-height: 100%;
        overflow: auto;
        .agreement_Model{
          padding-bottom: 50px;
          position: relative;
          z-index: 99;
          .agreement_box{
            position: relative;
            top: 50px;
            left: 0;
            margin: 0 auto 50px;
            background: #fff;
            border-radius: 2px;
            -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
            box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 900px;
            min-height: 820px;
            .agreement_Content{
              padding: 20px;
            }
            .agreement_Title{
              text-align: center;
              height: 60px;
              line-height: 60px;
              position: relative;
              i{
                position: absolute;
                top: 10px;
                right: 16px;
                font-size: 18px;
                cursor: pointer;
              }
              span{
                font-size: 26px;
                color: #000;
              }
            }
          }
        }
        .background{
          height: 100%;
          width: 100%;
          position: absolute;
          left:0;
          top:0;
          margin: auto 0;
          padding: 10px 0;
          min-height: 710px;
        }
        .main{
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -349px;
            margin-top:-350px;
            width: 698px;
            height: 700px;
            .el-icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                font-size: 20px;
                color: #ADADAD;
                cursor: pointer;
            }
            .contFr{
                background: rgba(255,255, 255, 0.85);
                width: 698px;
                height: 700px;
                padding:115px 155px;
                margin: 0 auto;
                border-radius: 10px;
                overflow: hidden;
                .cahngeLogin{
                    font-size: 14px;
                    margin-top: 8px;
                    span{cursor: pointer;}
                    .fl{
                        color: #EB4B12;
                    }
                }
                .goLogin{
                  text-align: center;
                  margin-top: 30px;
                  display: inline-block;
                  width: 100%;
                  font-size: 12px;
                  height: 12px;
                  line-height: 12px;
                }
                .goLogin:hover{
                  color: #EB4B12;
                }
                .loginType{
                    margin-top: 20px;
                    text-align: center;
                    img{
                    margin: 0 31px;
                    cursor: pointer;
                    }
                }
                .orStyle{
                    color: #a72126;
                    display: block;
                    text-align: center;
                    width: 100%;
                    position: relative;
                    font-size: 12px;
                    line-height: 12px;
                }
                .orStyle::after{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #a72126;
                    position: absolute;
                    left: 0;
                    top: 5px;
                }
                .orStyle::before{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #a72126;
                    position: absolute;
                    right: 0;
                    top: 5px;
                }
                .optins{
                    a,span{
                    font-size: 12px;
                    cursor: pointer;
                    }
                    span{
                    color: #a72126;
                    }
                }
                .formItems1{
                    height: 44px;
                    position: relative;
                    margin-bottom: 0px;
                    background-color: transparent;
                    font-size: 0;
                    /deep/.el-form-item__content{height: 100%;}
                    .clearfix{
                        vertical-align: top;
                        width: 51%;
                        height: 100%;
                        background-color: transparent;
                        padding: 0px 12px 0px 10px;
                        display: inline-block;
                        border-bottom: 1px solid #999;
                        margin-right: 16%;
                        vertical-align: bottom;
                        float: left;
                        /deep/.el-input__inner{
                            background-color: transparent;
                        }
                    }
                }
                .formItems{
                    background-color: transparent;
                    padding: 0px 15px;
                    padding-left: 38px;
                    height: 44px;
                    position: relative;
                    border-bottom: 1px solid #999;
                    font-size: 0;
                    /deep/.el-input__inner{background-color: transparent;}
                    .iconfonts{
                        position: absolute;
                        bottom: 6px;
                        left: -38px;
                        height: 23px;
                    }
                }
                .agreement{
                    font-size: 12px;
                    color: #ff0000;
                }
                .agreement:hover{
                    color: rgb(72, 125, 240);
                    cursor: pointer;
                }
                .register{
                    width: 100%;
                    height: 50px;
                    border-radius: 3px;
                    background-color:#EB4B12;
                    border: 0;
                    color: #fff;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                }
                .codeBox{
                    width: 32%;
                    height: 43px;
                    cursor: pointer;
                    vertical-align: bottom;
                    float: right;
                }
                .code{
                    font-size: 12px;
                    border: 0;
                    width: 32%;
                    vertical-align: bottom;
                    height:43px;
                    line-height: 43px;
                    background-color: #EB4B12;
                    border-radius: 4px;
                    color: #fff;
                    display: inline-block;
                    text-align: center;
                }
            }
        }
    }
/deep/.el-input__inner{border: 0;}
    /* 设置带边框的checkbox，选中后边框的颜色 */

/deep/.is-checked>.el-checkbox__inner{
  background-color: #EB4B12;
  border-color: #EB4B12;
}
/deep/.is-checked>.el-checkbox__label{
  color: #000;
}
/* 设置checkbox获得焦点后，对勾框的边框颜色 */
/deep/.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #EB4B12;
}

</style>


// WEBPACK FOOTER //
// src/components/RegisterPopup.vue